import { get } from "lodash";
import View from "./View";

const NoSubscription = ({ project, onNext, onBack, isAuraTer = false }) => {
  const next = (includedBeneficiaries) =>
    onNext({
      payload: {
        fields: {
          ...project.fields,
          includedBeneficiaries,
        },
      },
    });

  return (
    <View
      onNext={next}
      onBack={onBack}
      includedBeneficiaries={get(project, "fields.includedBeneficiaries")}
      isAuraTer={isAuraTer}
    />
  );
};

export default NoSubscription;
